/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
  `<template>
<style>
/*CSS-START*/
:host {
  display: block;
  --user-select-none: {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  @apply --font-base;
}

:host([value-only]) .button {
  display: none;
}

/* wrapper encapsulates the flex layout (normally wrappers are not required) */
.wdpr-counter {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: stretch;
  font-size: inherit;
  line-height: 1em;
}

.wdpr-counter .counter {
  @apply --font-light;
  color: var(--counter-color, var(--primary-dark));
  -webkit-text-fill-color: var(--counter-color, var(--primary-dark));
  line-height: 1em;
  text-align: center;
  vertical-align: middle;
  width: 100%;
}

.wdpr-counter .counter.non-editable {
  @apply --user-select-none;
  display: flex;
  justify-content: center;
  flex-basis: auto;
}

.wdpr-counter #editableWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  height: 1em;
  box-shadow: 0 1px 3px 0 var(--counter-editable-wrapper-box-shadow-color, var(--secondary-message-detail));
  box-sizing: border-box;
  border: 1px solid transparent;
  margin: 0 2px 3px;
  border-radius: 0.15em;
  font: inherit;
  overflow: hidden;
}

.wdpr-counter #editableWrapper #editableInput {
  border: none;
  padding: 0;
  -moz-appearance: textfield;
  font-size: inherit;
  @apply --font-light;
}

.wdpr-counter #editableWrapper #editableInput::-webkit-outer-spin-button, .wdpr-counter #editableWrapper #editableInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.wdpr-counter #editableWrapper #editableInput[disabled] {
  background: none;
  @apply --user-select-none;
}

.wdpr-counter #editableWrapper #editableInput::-ms-clear {
  width: 0;
  height: 0;
}

.wdpr-counter .button {
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 0;
  @apply --user-select-none;
}

.wdpr-counter .button .icon {
  color: var(--counter-icon-color, var(--primary));
  background-color: var(--counter-icon-background-color, white);
  border: 1px solid;
  border-color: var(--counter-icon-background-color, var(--primary));
  border-radius: var(--counter-icon-border-radius, 20px);
  height: var(--counter-icon-height, 40px);
  width: var(--counter-icon-width, 40px);
  display: inline-block;
  top: 0;
  left: 0;
}

.wdpr-counter .button .icon #minus {
  fill: var(--counter-icon-color, var(--primary));
}

.wdpr-counter .button .icon #plus {
  fill: var(--counter-icon-color, var(--primary));
}

.wdpr-counter .button:hover:not([disabled]) .icon {
  background-color: var(--counter-icon-background-hover-color, white);
  border-color: var(--counter-icon-background-hover-color, var(--secondary-hover));
}

.wdpr-counter .button:hover:not([disabled]) .icon #minus {
  fill: var(--counter-icon-hover-color, var(--secondary-hover));
}

.wdpr-counter .button:hover:not([disabled]) .icon #plus {
  fill: var(--counter-icon-hover-color, var(--secondary-hover));
}

.wdpr-counter .button:active:not([disabled]) .icon {
  background-color: var(--counter-icon-background-active-color, white);
  border-color: var(--counter-icon-background-active-color, var(--secondary-hover));
}

.wdpr-counter .button:active:not([disabled]) .icon #minus {
  fill: var(--counter-icon-active-color, var(--secondary-hover));
}

.wdpr-counter .button:active:not([disabled]) .icon #plus {
  fill: var(--counter-icon-active-color, var(--secondary-hover));
}

.wdpr-counter .button:focus:not([disabled]) {
  outline-color: initial;
  outline-color: -webkit-focus-ring-color;
  outline-style: auto;
}

.wdpr-counter .button[disabled] .icon,
.wdpr-counter .button[disabled]:focus .icon,
.wdpr-counter .button[disabled]:hover .icon {
  color: var(--counter-icon-disabled-color, var(--primary-disabled));
  background-color: var(--counter-icon-background-disabled-color, white);
  border-color: var(--counter-icon-background-disabled-color, var(--primary-disabled));
  cursor: default;
}

.wdpr-counter .button[disabled] .icon #minus,
.wdpr-counter .button[disabled]:focus .icon #minus,
.wdpr-counter .button[disabled]:hover .icon #minus {
  fill: var(--counter-icon-disabled-color, var(--primary-disabled));
}

.wdpr-counter .button[disabled] .icon #plus,
.wdpr-counter .button[disabled]:focus .icon #plus,
.wdpr-counter .button[disabled]:hover .icon #plus {
  fill: var(--counter-icon-disabled-color, var(--primary-disabled));
}

.hidden,
[hidden] {
  display: none !important;
}

.visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
}
/*CSS-END*/
</style>
</template>`;

styleElement.register('wdpr-counter-style');
